import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert'; // react-confirm-alert paketini kullanıyoruz
import 'react-confirm-alert/src/react-confirm-alert.css'; // Stil dosyasını ekliyoruz
import { useChat } from './ChatContext'; // Use the necessary imports based on your context
import { GetExistingWebChatReportsForAlbinaSoftAgentResponse, ReportList } from '../../Model/Response/ClientAgent/GetExistingWebChatReportsForAlbinaSoftAgentResponse';
import { AddChatSessionToExistingReport, GetExistingWebChatReportsForAlbinaSoftAgent } from '../../Controller/Api/ClientAgentController';
import { ApiBaseResponse, ResponseCode } from '../../Model/Response/Common/ApiBaseResponse';
import LoadingButton from '../Components/CoreComponents/button';
import { GetExistingWebChatReportsForAlbinaSoftAgentRequest } from '../../Model/Request/ClientAgent/GetExistingWebChatReportsForAlbinaSoftAgentRequest';
import { AddChatSessionToExistingReportRequest } from '../../Model/Request/ClientAgent/AddChatSessionToExistingReportRequest';
import { DisplayType, StatusEnum, useShowStatusMessage } from '../Components/CoreComponents/StatusMessage';
import { EndSessionByAgentRequest } from '../../Model/Request/SignalR/EndSessionByAgentRequest';
import { GlobalOperations } from '../../Controller/Common/GlobalOperations';

const ExistingReportsPopup: React.FC<{ serviceId: number, sessionOwnerTel: string, handleClose: () => void }> = ({ serviceId, sessionOwnerTel, handleClose }) => {
    const [reports, setReports] = useState<ReportList[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const { currentSession, setMessages } = useChat(); // useChat'ten setMessages ve setActiveSessions alınıyor

    // API çağrısını gerçekleştirecek fonksiyon
    const fetchReports = async () => {
        try {
            // Simulate an API call with the request
            const request: GetExistingWebChatReportsForAlbinaSoftAgentRequest = {
                serviceId,
                sessionOwnerTel,
            };

            // API çağrısı yapılacak
            let response: ApiBaseResponse<GetExistingWebChatReportsForAlbinaSoftAgentResponse> | null =
                await GetExistingWebChatReportsForAlbinaSoftAgent(request);

            if (!response || !response.content || response.responseCode !== ResponseCode.OK) {
                return;
            }

            setReports(response?.content?.reportList);
        } catch (err) {
            setError('Raporlar alınırken hata oluştu.');
        } finally {
            setLoading(false);
        }
    };

    //görüşmeyi mevcut bir rapora ekleme
    const showStatusMessage = useShowStatusMessage();
    const addToExistingReport = async (reportId: number, onClose: () => void) => {
        try {
            // API işlemleri veya gerekli kodlar burada yer alacak
            console.log(`Rapor ${reportId} mevcut rapora ekleniyor...`);

            let request: AddChatSessionToExistingReportRequest = {
                reportId: reportId,
                sessionId :   GlobalOperations.ActiveSessionId
            }


            let response: ApiBaseResponse<null> | null =
                await AddChatSessionToExistingReport(request);

            if (!response || response.responseCode != ResponseCode.OK) {
                //TODO hata mesajı göster
                return;
            }

            // Başarılı ise
            showStatusMessage({
                header: response?.textHeader ?? 'Başarı',
                text: response?.text ?? 'İşlem başarılı',
                status: StatusEnum.SUCCESS,
                direction: 'down',
                duration: 5000,
                displayType: DisplayType.TOP,
            });


            // 2. Mesajları temizle ve bir konuşma seçin yazısını göster
            setMessages([]); // Mesajları temizle

            let reuqest: EndSessionByAgentRequest = {
                sessionId :   GlobalOperations.ActiveSessionId ,
                auth: GlobalOperations.UserToken
            }
    
            if (GlobalOperations.SignalRConnection == null) {
                console.error("SignalR bağlantısı yok.");
                return;
            }
            let response2: boolean = await GlobalOperations.SignalRConnection.invoke("endSessionByAgent", reuqest);
    
    
    
            // Aktif oturumu sıfırla
            GlobalOperations.ActiveSessionId = 0;
    
            // Onay modalını kapatıyoruz
            onClose();
        } catch (err) {
            setError('Rapor eklenirken hata oluştu.');
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchReports();
    }, []);

    // Rapor ekleme işlemine başlamadan önce kullanıcı onayı almak için fonksiyon
    const handleAddReport = (reportId: number) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                handleClose();

                return (
                    <div className="custom-ui-2" style={{ zIndex: 1060 }}>
                        <div className="custom-modal">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content custom-modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Rapor Eklemek İstiyor musunuz?</h5>
                                    </div>
                                    <div className="modal-body">
                                        <p>Mevcut rapora ekleme işlemi yapılacak. Devam etmek istiyor musunuz?</p>
                                    </div>
                                    <div className="modal-footer">
                                        <Button variant="secondary" onClick={onClose}>
                                            İptal
                                        </Button>
                                        <LoadingButton label="Görüşmeyi Mevcut Rapora Ekle" onClick={() => addToExistingReport(reportId, onClose)} />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            },
        });
    };

    if (loading) {
        return <div>Yükleniyor...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <Modal show={true} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Eski Raporlar</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {reports.length > 0 ? (
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Rapor Ekle</th>
                                <th>Kullanıcı Adı Soyadı</th>
                                <th>Kullanıcı Talebi</th>
                                <th>Yapılan İşlem</th>
                                <th>Rapor Tarihi</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reports.map((report) => (
                                <tr key={report.reportId}>
                                    <td>
                                        <LoadingButton label="Rapora Ekle" onClick={() => handleAddReport(report.reportId)} />


                                    </td>
                                    <td>{report.clientNameSurname}</td>
                                    <td>{report.customerRequest}</td>
                                    <td>{report.agentProcess}</td>
                                    <td>{new Date(report.reportDate).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div>Eski rapor bulunamadı.</div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Kapat
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ExistingReportsPopup;
